<template>
    <div>
        <v-file-viewer ref="fileViewer"></v-file-viewer>

        <b-modal id="upload-file" title="Dosya Yükle" no-close-on-esc no-close-on-backdrop>
            <employee-document-upload v-model="file" :errors="errors"></employee-document-upload>
            <template #modal-footer><v-executer :loading="loading" text="Yükle" :action="uploadFile"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :fields="fields"
                    :buttons="buttons"
                    :add-callback="createNew"
                    name="employee-documents"
                    :items-provider="provider"
                    :initial-load="id != '0' || id != 0 ? true : false"
                    :settings="false"
                    pagination="server"></v-table>
    </div>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations' 
import Additional from '@/utilities/additional'
import EmployeeDocumentUpload from './EmployeeDocumentUpload.vue'
import VFileViewer from '@/components/VFileViewer.vue'

export default {
    components:{
        EmployeeDocumentUpload,
        VFileViewer
    },
    props:{
        id:[String,Number],
    },
    data(){
        return{
            fields:[
                {name:"Dosya Türü",key:"FileType",sortable:true,thClass:"w-25",sortKey:'EntityFileType'},
                {name:"Başlangıç Tarihi",key:"StartDate",thClass:"w-25"},
                {name:"Bitiş Tarihi",key:"EndDate",thClass:"w-25"},
                {name:"Yükleme Tarihi",key:"CreateDate",sortable:true,thClass:"w-25",sortKey:'CreateTime'}
            ],
            buttons:[
                { text:"İndir",key:"download",icon:"DownloadIcon",variant:"primary",action:this.download },
                { text:"Görüntüle",key:"view",icon:"EyeIcon",variant:"success",action:this.view },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            loading:false,
            file:{
                Id: null,
                EmployeeId: null,
                File: null,
                StartDate:null,
                EndDate:null,
                SystemCode: null
            },
            errors:{}
        }
    },
    watch:{
        id(){
            this.$refs.table?.refresh()
        }
    },
    methods:{
        clearForm(){
            this.file.Id = null
            this.file.EmployeeId = null
            this.file.File = null
            this.file.StartDate = null 
            this.file.EndDate = null
            this.file.SystemCode = null
        },
        provider(data){
            return EmployeeOperationsApi.Employee.File.Table({PaginationRequestModel:data,EmployeeId:this.id})
        },
        refresh(){
            this.$refs.table.refresh()
        },
        createNew(){
            this.clearForm()
            this.$showModal('upload-file')
        },
        download(item){
            this.$refs.table.rowLoading(true)
            Additional.GetBlobFile(item.FileDownloadUrl).then(res=>{
                Additional.DownloadFile(res.data,item.FileName)
                this.$refs.table.rowLoading(false)
            }).catch(err=>{
                this.$result(null,err)
                this.$refs.table.rowLoading(false)
            })
        },
        view(item){
            this.$refs.fileViewer.view(item.FileDownloadUrl)
        },
        async uploadFile(){
            this.loading = true
            this.file.EmployeeId = this.id
            let formData = await Additional.ToFormData(this.file,['File'])
            EmployeeOperationsApi.Employee.File.Upload(formData).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('upload-file')
                }
            }).catch(err=>{
                this.$result(null,err)
                this.loading = false
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.FileType} türlü dosyayı silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    EmployeeOperationsApi.Employee.File.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
    }
}
</script>

<style>

</style>